import { useQuery } from '@tanstack/react-query';

import { getProductCategories } from '../queries/products';
import { useAuthStore } from '../stores';

export const useGetProductCategory = (size: number, page: number) => {
  const session = useAuthStore();
  return useQuery({
    queryKey: ['ProductCategory', size, page],
    queryFn: () => getProductCategories(session.access_token, { size, page }),
  });
};
